import { reskinStyles } from '../theme-variant';

const overrideAutocomplete = (theme) => {
  theme.overrides.MuiAutocomplete = {
    popupIndicator: {
      marginRight: theme.spacing(2)
    },
    // Reskin: a menu's shadow and corners. Papers lose their elevation-1 shadow in the new look (paper.js), which
    // left autocomplete popups white on white.
    paper: reskinStyles(theme, {
      boxShadow: theme.shadows[8],
      borderRadius: theme.sizes.innerCorners,
      '&:empty': { boxShadow: 'none' }
    }),
    // Reskin: the same option highlight and selected fill as the dropdown menus (list-items.js).
    option: reskinStyles(theme, {
      '&[data-focus="true"]': { backgroundColor: theme.colorPalette.beige_50 },
      '&[aria-selected="true"]': { backgroundColor: theme.colorPalette.beige_25, fontWeight: 700 }
    })
  };
};

export default overrideAutocomplete;
